export default "__VITE_ASSET__DyN3_Cat__"